import { Dropdown } from 'components/ui'
import { AIContext } from 'contexts/AIContext'
import React, { useContext } from 'react'
import { HiChevronDown } from 'react-icons/hi'

const AIVideoDropdownSizes = ({ size, setSize, model, className, parentClassName, disabled = false }) => {
    
    const { aiVideoModels } = useContext(AIContext);
    
    const currentModel = aiVideoModels?.find(m => m.model === model);
    const availableSizes = currentModel?.availableSizes || ["16:9", "1:1", "9:16"];
    
    const sizeOptions = [
        { id: "16:9", label: "16:9", icon: "" },
        { id: "1:1", label: "1:1", icon: "" },
        { id: "9:16", label: "9:16", icon: "" }
    ].filter(option => availableSizes.includes(option.id));

    const currentSize = sizeOptions.find(s => s.id === size) || sizeOptions[0];

    const Toggle = (
        <div className={`flex items-center justify-center gap-2 ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'} ${className}`}>
            <span className="text-lg">{currentSize?.icon}</span>
            <span className="font-medium">{currentSize?.label}</span>
            <HiChevronDown className="text-lg" />
        </div>
    );

    return (
        <div className={parentClassName}>
            <Dropdown 
                renderTitle={Toggle}
                placement="bottom-end"
                className="!w-full"
                disabled={disabled}
            >
                {sizeOptions.map((sizeOption) => (
                    <Dropdown.Item 
                        key={sizeOption.id}
                        eventKey={sizeOption.id} 
                        onSelect={() => !disabled && setSize(sizeOption.id)}
                        className={`flex items-center justify-center !py-2 !text-center hover:!bg-gray-100 dark:hover:!bg-gray-900/20 gap-3 ${size === sizeOption.id ? 'bg-purple-50 dark:bg-purple-900/20' : ''} ${disabled ? 'cursor-not-allowed opacity-50' : ''}`}
                    >
                        <div className="font-medium">{sizeOption.label}</div>
                    </Dropdown.Item>
                ))}
            </Dropdown>
        </div>
    )
}

export default AIVideoDropdownSizes
